import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    status: null,
    message: null
};

const errorReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.UTILITY_START:
        case actionTypes.UTILITY_SUCCESS:
        case actionTypes.TERRITORY_START:
        case actionTypes.TERRITORY_SUCCESS:
        case actionTypes.COMMISSIONPLAN_START:
        case actionTypes.COMMISSIONPLAN_SUCCESS:
        case actionTypes.PRODUCT_START:
        case actionTypes.PRODUCT_SUCCESS:
        case actionTypes.EMAIL_START:
        case actionTypes.EMAIL_SUCCESS:
        case actionTypes.PHONENUMBER_START:
        case actionTypes.PHONENUMBER_SUCCESS:
        case actionTypes.MLSPROVIDER_START:
        case actionTypes.MLSPROVIDER_SUCCESS:
        case actionTypes.FRANCHISE_START:
        case actionTypes.FRANCHISE_SUCCESS:
        case actionTypes.OFFICE_START:
        case actionTypes.OFFICE_SUCCESS:
        case actionTypes.AUTHENTICATION_START:
        case actionTypes.AUTHENTICATION_SUCCESS:
        case actionTypes.ERROR_CLEAR: {
            return updateState(state, { status: null, message: null });
        }
        case actionTypes.UTILITY_FAIL:
        case actionTypes.TERRITORY_FAIL:
        case actionTypes.COMMISSIONPLAN_FAIL:
        case actionTypes.PRODUCT_FAIL:
        case actionTypes.EMAIL_FAIL:
        case actionTypes.COMMISSIONPLANFEETEMPLATE_FAIL:
        case actionTypes.PHONENUMBER_FAIL:
        case actionTypes.MLSPROVIDER_FAIL:
        case actionTypes.FRANCHISE_FAIL:
        case actionTypes.OFFICE_FAIL:
        case actionTypes.FRANCHISENEWS_FAIL:
        case actionTypes.AUTHENTICATION_FAIL: {      
            let message = (action.error && action.error.message) ? action.error.message : constants.ERROR_GENERIC;
            const status = (action.error && action.error.status) ? action.error.status : null;

            if (status === 401) {
                message = 'Oops! You might have been logged out or do not have access.';
                localStorage.clear();
            }

            return updateState(state, { status: status, message: message });
        }
        default: {
            return state;
        }
    }
};

export default errorReducer;